import React from 'react'
import './NavigationWithSideBar.scss'
import { Spinner } from 'react-bootstrap'

export interface NavigationSidebarSection {
  id: string
  label: React.ReactNode
  disabled?: boolean
  hasError?: boolean
  isLoading?: boolean
}

export interface NavigationSidebarProps {
  sections: NavigationSidebarSection[]
  activeSectionId: string
  onSectionClick: (id: string) => void
  NavigationFooter?: React.ReactNode
}

export const NavigationSidebar: React.FC<NavigationSidebarProps> = ({ sections, activeSectionId, onSectionClick, NavigationFooter }) => {
  return (
    <nav className='scroll-navigation__sidebar'>
      <ul className='list-unstyled mb-0'>
        {sections.map((section) => (
          <li key={section.id} className='mb-2'>
            <button
              disabled={section.disabled || false}
              type='button'
              onClick={() => onSectionClick(section.id)}
              className={`btn w-100 rounded-0 scroll-navigation__nav-button d-flex align-items-center justify-content-between ${
                activeSectionId === section.id ? 'scroll-navigation__nav-button--active' : 'scroll-navigation__nav-button--inactive'
              }`}
            >
              <span className='zocks-text-gray-900'>{section.label}</span>
              {section.isLoading ? <Spinner size='sm' /> : section.hasError && <i className='bi bi-exclamation-triangle text-warning' />}
            </button>
          </li>
        ))}
      </ul>
      {NavigationFooter ? <div>{NavigationFooter}</div> : null}
    </nav>
  )
}
